import React, { useEffect, useState } from "react";
import ArrowUpIcon from "../icons/ArrowUpIcon";
import SuccessCheckIcon from "../icons/SuccessCheckIcon";
import CustomCheckbox from "../common/CustomCheckbox";
import { selectAllCallBack } from "./selectAllCallback";
import { JobsDataType } from "../../types/api-response";
import { folderPagePath, formatDate } from "../../utils";
import { useLazyDownloadExcelQuery } from "../../redux/apis/manageJobPostingHooks";
import { getUserDetails } from "../../utils/getUserDetails";
import AdditionalContent from "./AdditionalContent";
import EditIcon from "../../resources/images/icons/EditIcon";
import CopyIcon from "../../resources/images/icons/CopyIcon";
import DownloadXls from "../../resources/images/icons/DownloadXls";
import getMappedJobType from "../common/utils/getMappedJobType";
import CommonEmptyState from "./CommonEmptyState";
import DownloadXlsModal from "../mjpModals/DownloadXlsModal";
import { useAppSelector } from "../../redux/store";
import { JOB_TITLE_CHAR_LIMIT_ELLIPSIS } from "../../constants/tabs";
import FolderName from "./FolderName";

interface Props {
  checkedData: JobsDataType[];
  setCheckedData: Function;
  jobsData: JobsDataType[] | undefined;
  onDClick?: Function;
  triggerInventory: Function;
}

const Inbound = ({
  checkedData,
  setCheckedData,
  jobsData,
  onDClick = () => {},
  triggerInventory,
}: Props) => {
  const [clickedRow, setClickedRow] = useState<number | null>(null);
  const [infocus, setInfocus] = useState<number | null>(null);
  const [selectedRowData, setSelectedRowData] = useState<
    JobsDataType[] | null
  >();
  const openModal: any = useAppSelector(
    (state: any) => state?.download?.openModal
  );

  const [downloadExcel, {}] = useLazyDownloadExcelQuery();
  const userDetails = getUserDetails();

  const handleEllipsesClick = (item: number) => {
    setClickedRow((prevClickedRow) => (prevClickedRow === item ? null : item));
  };

  const handleDownloadExcel = (jobId: number,e:React.MouseEvent) => {
    onDClick(jobId,e);
  };


  if ((jobsData || []).length === 0) {
    return <CommonEmptyState text="You don’t have any sourced job!" />;
  }

  return (
    <div className="search-result_container">
      {(jobsData || []).map((job, index) => {
        const {
          jobId,
          title,
          jobType,
          hasScreening,
          postedDate,
          renewalDate,
          recruiterName,
          location,
          folderName,
          views,
          applicationCount,
          applicationCountUnread,
          recommended,
          jobPostingType,
          updateDate
        } = job || {};

        const isRenewed = Number(renewalDate?.length) > 0;

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div key={String(jobId)} className={`search-result_card${infocus==jobId ? ' infocus': ''}`}>
              <div className="search-result_card_lt">
                <CustomCheckbox
                  checkboxData={{
                    label: "",
                    id: "card_" + String(jobId),
                    callBack: () =>
                      selectAllCallBack({ job, checkedData, setCheckedData }),
                  }}
                  checked={checkedData
                    ?.map((data) => data?.jobId)
                    ?.includes(jobId)}
                />
              </div>

              <div className="search-result_card_rt_check">
                <div className="search-result_title-container">
                  <div className="search-result_card_row">
                    <span
                      className={`main_title clickable${title?.length > JOB_TITLE_CHAR_LIMIT_ELLIPSIS ? " allow_ellipsis":""}`}
                      role="button"
                      onClick={() =>
                        window.open(
                          `${window.location.origin}/edge/${folderPagePath}?folderID=${jobId}&autoMatch=false&jobLinked=true`,
                          "_blank"
                        )
                      }
                    >
                      {title}
                    </span>
                    <span className="faded subtitle">
                      ({`${jobPostingType=='SJS' ? getMappedJobType('SOCIAL') : getMappedJobType(jobType?.name)}`})
                    </span>
                  </div>
                </div>

                <div className="list_title_container">
                  <div
                    style={{
                      display: "flex",
                      fontSize: "12px",
                      margin: "6px 0",
                      lineHeight: "20px",
                    }}
                  >
                    {!isRenewed ? 
                      <div>Posted on: {postedDate ? formatDate(postedDate) : '-'}</div> :
                      <div>Renewed on: {renewalDate ? formatDate(renewalDate) : '-'}</div> 
                    }
                    <div className="vertical_line" />

                    <div>
                      <span className="faded">Posted by: </span>
                      {recruiterName}
                    </div>
                    <div className="vertical_line" />

                    <div>
                      <span className="faded">Location: </span>
                      {location || ""}
                    </div>
                  </div>
                </div>

                <div className="horizontal_seperator" />
                <div className="search-result_card_row">
                  <div className="folder_table_container">
                    <div className="folder_table_item">
                      <div className="folder_column faded">Folder</div>
                      <div className="main_title folder-name cp-cursor"
                        onClick={() =>
                          window.open(
                            `${window.location.origin}/edge/${folderPagePath}?folderID=${jobId}&autoMatch=false&jobLinked=true`,
                            "_blank"
                          )
                        }
                      >
                      <FolderName title={folderName}>
                      {folderName}
                      </FolderName>
                      </div>
                    </div>

                    <div className="folder_table_item">
                      <div className="folder_column faded">Views</div>
                      <div className="main_title">{views}</div>
                    </div>

                    <div className="folder_table_item">
                      <div className="folder_column faded">Applicants</div>
                      <div className="main_title">
                        {applicationCount}
                      </div>
                    </div>
                    <div className="folder_table_item">
                      <div className="folder_column faded">Recommended</div>
                      <div className="main_title cp-cursor"
                       onClick={() =>
                        typeof recommended == 'number' &&
                        window.open(
                          `${window.location.origin}/edge/${folderPagePath}?folderID=${jobId}&tab=Recommended&autoMatch=true&jobLinked=true`,
                          "_blank"
                        )
                      }
                      >{typeof recommended == 'number' ? recommended : "-"}</div>
                    </div>
                  </div>
                  <div className="search-result_flex">
                  <div
                      role="button"
                      className="search-result_active-icons search-result_disabled"
                      title="Edit"
                      // onClick={() =>
                      //   window.open(
                      //     `${window.location.origin}/edge/jobposting/new-job-posting/edit/${jobId}`,
                      //     "_blank"
                      //   )
                      // }
                    >
                      <EditIcon />
                    </div>
                    <div
                      role="button"
                      className="search-result_active-icons search-result_disabled"
                      title="Copy"
                      // onClick={() =>
                      //   window.open(
                      //     // `${window.location.origin}/v4/jobposting/copy/${jobId}`,
                      //     `${window.location.origin}/edge/jobposting/new-job-posting/copy/${jobId}`,
                      //     "_blank"
                      //   )
                      // }
                    >
                      <CopyIcon />
                    </div>
                    <div
                      role="button"
                      className="search-result_active-icons search-result_disabled"
                      // onClick={() => handleDownloadExcel(jobId)}
                    >
                      <DownloadXls />
                    </div>
                    <div
                      role="button"
                      className="search-result_active-icons"
                      onClick={() => {
                        if(infocus == null) {
                          setSelectedRowData([job]);
                          setInfocus(jobId)
                          handleEllipsesClick(jobId);
                        }
                      }}
                    >
                      <span className="menu-3-dots" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {clickedRow === jobId && (
              <AdditionalContent
                selectedRowData={selectedRowData}
                setClickedRow={setClickedRow}
                callbackOnClose={() => setInfocus(null)}
              />
            )}
            {!!openModal &&
              sessionStorage.getItem("mjpKey") == jobId.toString() && (
                <DownloadXlsModal
                  key={jobId + index}
                  id={jobId}
                  triggerInventory={triggerInventory}
                />
              )}
          </div>
        );
      })}
    </div>
  );
};

export default Inbound;
